import { Environment } from './environment.interface';

const env: Environment = {
  production: false,
  name: 'dev',
  apiUrl: 'http://10.11.10.129:7171/api',
  frontUrl: 'http://10.11.10.129:4200/',
  version: 'v1.0.0',
  grant_type: 'password',
  client_secret: '8M1vKFYW4qcxeRFGhbMiUneXszrZVsv2',
  client_id: 'scl-api',
  keyCloackAdminUrl: 'http://10.11.10.121:8080/admin/realms/SCL-Qa',
  kcUrl: 'http://10.11.10.121:8080/realms/SCL-Qa/protocol/openid-connect',
  cryptoKey: 'sclbo24',
};

export const environment = { ...env, enableLogin: true } as Environment;
